import { UseFormGetFieldState, FieldValues, Path } from 'react-hook-form'

export const getFormErrorMessage = <T extends FieldValues>(
  defaultValues: T,
  getFieldState: UseFormGetFieldState<T>
): string => {
  const fieldsToCheck = Object.keys(defaultValues) as Path<T>[]
  const errorMessages: string[] = []

  fieldsToCheck.forEach((fieldName) => {
    const fieldState = getFieldState(fieldName)

    if (fieldState.error?.message) {
      errorMessages.push(fieldState.error.message)
    }
  })

  if (errorMessages.length === 0) {
    return 'Nastala neznáma chyba.'
  }

  return errorMessages.join('\n')
}
